module.exports = __webpack_public_path__ + "static/img/ph-sigh-up-head.3f07c106.png";